<template>
  <div id="Login" style="background-color: #F7F0E6" class="login fullheight" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CContainer fluid class="fullheight"> 
      <CRow class="align-start align-md-center fullheight">
        <CCol cols="12" md="12" style="margin-top: 100px !important"  :style="'text-align: center; padding-top: 100px; padding-bottom: '+(height - 700)+'px;'">
          <div class="login__container" style="margin: auto; padding: 30px 20px;">
            <div class="login__inner" style="">
              <div class="login__image text-center">
                <img src="logo_confirmame.jpg" alt="Logo Oscuro" style="width: 150px;"> <br><br> Para completar el proceso debes definir una nueva contraseña de acceso.<br><br>
              </div>
              <div class="login__form">
                <CRow>
                  <CCol sm="12">
                    <CInput
                      :value.sync="$v.form.password.$model"
                      :isValid="checkIfValid('password')"
                      label="Contraseña"
                      type="password"
                      placeholder=""
                      invalidFeedback="Este campo es requerido con al menos 8 caracteres."
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CInput
                      :value.sync="$v.form.password2.$model"
                      :isValid="checkIfValid('password2')"
                      label="Confirmar Contraseña"
                      type="password"
                      placeholder=""
                      invalidFeedback="Este campo es requerido con al menos 8 caracteres."
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CButton type="button" color="info" style="width: 100%" @click="active">ASIGNAR NUEVA CONTRASEÑA</CButton>
                  </CCol>
                </CRow>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
    </CContainer>
    <loading :active="visible" :can-cancel="true" loader="bars"></loading>
    <CToaster placement="top-end">
      <template>
        <CToast v-for="(toast, key) in toasts" :color="toast.color" v-bind="toast" :key="'toast' + key" :show="true">
          {{toast.content}}
        </CToast>
      </template>
    </CToaster>
  </div>
</template>

<script>

import ws from '../../../services/login';
import store from '../../../store';
import Loading from 'vue-loading-overlay/dist/vue-loading.js';
import 'vue-loading-overlay/dist/vue-loading.css';
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength, integer, email} from "vuelidate/lib/validators"

export default {
    name: 'RecoveryForm',
    components: {      
      Loading
    },
    data () {
        return {
          height: 400,
          form: {
              id: 0,
              code: '',
              password: '',
              password2: ''

          },
          user: false,
          account: false,
          fiscal: false
        }
    },
    mounted: async function() {
      this.height = window.innerHeight;
      this.form.id = await this.$route.params.id;
      this.form.code = await this.$route.params.code;      
    },
    methods: {
        async active () {          
            this.$v.$touch();

            if (this.isValid) {
              this.loading();
                if(!this.validatePasswords(this.form.password, this.form.password2)){
                  return;
                }
                
                let response = await ws.recoveryPassword(this.form);                
                if(response.type == "success"){
                  this.loaded();
                  window.location.href = "/#/login";                 
                }
                else{
                  this.loaded();
                  this.showToast("error",response.message);
                }
            }            
        },
        validatePasswords (password, password2) {
            if(password.length >= 0 && password.length < 8){
              alert("La contraseña debe tener al menos 8 caracteres");
              return false;
            }

            if(password != password2){
              alert("Las contraseñas no coinciden");
              return false;
            }

            return true;
        },
        checkIfValid (fieldName) {
            const field = this.$v.form[fieldName]
            if (!field.$dirty) {
                return null
            }
            
            return !(field.$invalid)
        },
        showToast(type, message){
            store.commit('toast', {color: type, message: message});
        },
        loading(){
            store.commit('loading');
        },
        loaded(){
            store.commit('loaded');
        }
    },
    computed: {
        formString () { return JSON.stringify(this.form, null, 4) },
        isValid () { return !this.$v.form.$invalid },
        isDirty () { return this.$v.form.$anyDirty },
        visible() {
          return store.state.isLoading;
        },
        toasts () {
          return store.state.toasts;
        },
    },
    mixins: [validationMixin],
    validations: {
        form: {
            id: {},
            code: {},
            password: {
                required,
                minLength: minLength(8)
            },
            password2: {
                required,
                minLength: minLength(8)
            }
        }
    },
}
</script>